/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.skills.SkillModeScope
*/
export var SkillModeScope;
(function (SkillModeScope) {
    SkillModeScope["USER"] = "USER";
    SkillModeScope["PROJECT"] = "PROJECT";
    SkillModeScope["TENANT"] = "TENANT";
})(SkillModeScope || (SkillModeScope = {}));
//# sourceMappingURL=SkillModeScope.js.map